import { useEffect, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, GridLegacy as Grid, InputLabel, Typography } from '@mui/material';
import styled from "@emotion/styled";
import {  UploadFile } from "@mui/icons-material";
import { red } from "@mui/material/colors";
import { useUploadFile } from "../../hooks/useUploadFile";
import { ActionTypes } from "../../store/AppStore";
import { AxiosInstance, DialogType, getUrlImage } from "../../utils/constants";


const ImageBackgroundContainer = styled.div`
    width:100%;
    height:400px;
    background-color:#e3e3e3;
    display:flex;
    justify-content:center;
    align-content:center;
    align-items:center;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
`;
const TextInputHolder = styled.textarea`
    border-color:#016B61;
    border-width:1px;
    width:100%;
    font-size:1rem;
    font-family: 'Plus Jakarta Sans', 'Manrope', 'Helvetica Neue', sans-serif;
    border-radius:12px;
    padding:3px;
`;
const ErrorText = styled.span`
    color:${red[500]};
    font-size:0.8rem;
`;



export default function ModalFichaTecnica({
    isOpen,
    dataFichaTecnica,
    setIsVisibleFichaTecnica,
    dispatch=()=>{},
    updateProdList= ()=>{},
    disabled
}){
    const {fichaTecnica = [],cod_producto} = dataFichaTecnica;

    const [controlledInfo,setControlledInfo] = useState([]);
    
     const setImagenFichaTecnica = (img_data)=>{

        const item =  controlledInfo.find( item=>item.atributo_tipo_atributo === 'IMAGEN' );
        if ( item ){
            ChangeItemValue(item.atributo_codigo,img_data);
        }
        
    }

    const {
        clickUploadFile,
        InputFileRaw
    } = useUploadFile({
        default_value:controlledInfo.find( item=>item.atributo_tipo_atributo === 'IMAGEN' )?.valor,
        keyValue:"imagen_product",
        code_entity_save:null,
        setImageValue:setImagenFichaTecnica,
        update_image_product:false
      
    }); 

    useEffect(()=>{
        setControlledInfo(fichaTecnica);
    },[dataFichaTecnica]);

    const renderItem = (element)=>{
      
        if ( element.atributo_tipo_atributo === 'IMAGEN' ){
            return  <>
            <ImageBackgroundContainer style={element.valor?{backgroundImage:'url('+getUrlImage(element.valor)+')'}:{}} onClick={clickUploadFile}  >
                        <Button disabled={disabled} style={element.valor?{background:"transparent"}:{}} size="small" variant="contained" startIcon={<UploadFile />}  >Subir Imagen</Button>
                    </ImageBackgroundContainer>
                    {element.errorInput && <ErrorText>{element.errorInput}</ErrorText>}
            </>
        }
        if ( element.atributo_tipo_atributo === 'TEXTO' ){
            return <>
            <InputLabel>{element.atributo_descripcion} {element.atributo_requerido?'(Requerido)':'(Opcional)'}</InputLabel>
            <TextInputHolder disabled={disabled}  value={element.valor}  onChange={e=>ChangeItemValue(element.atributo_codigo,e.target.value)}  rows={2} cols={1}  />
            {element.errorInput && <ErrorText>{element.errorInput}</ErrorText>}
            
            </>
        }
        return <></>;
    }

    const ChangeItemValue = (id_element,value)=>{
            var copyInputs = [...controlledInfo];
            const indexFound = copyInputs.findIndex( item=> item.atributo_codigo === id_element );
            copyInputs[indexFound].valor = value;
            setControlledInfo(copyInputs);
            

    }

    const  Clases = (()=>{
        let arrayOfClases = [];
        (fichaTecnica  || []).forEach( item=>{
           if ( !arrayOfClases.find( ele=>ele.cod === item.clase_cod ) ){
            arrayOfClases.push({
                cod:item.clase_cod,
                label:item.clase_descripcion
            });
           }
        } );
        return arrayOfClases;
    })()
    

    const onSendForm = ()=>{
        console.log({controlledInfo});
        const CopyInfo = [...controlledInfo];
        let conErrores = false;
        CopyInfo.forEach( (item,index)=>{
            if ( Boolean( item.atributo_requerido ) && !item.valor  ){
                conErrores= true;
                CopyInfo[index].errorInput = "Campo requerido";
            }else{
                CopyInfo[index].errorInput = undefined;
            }
        } );
        setControlledInfo(CopyInfo);
        if (conErrores){
            dispatch({
                type:ActionTypes.setModalInfo,
                data:{
                    title:"Advertencia",
                    message:"Se han encontrado algunos campos no diligenciados, Por favor revisar",
                    type:DialogType.informativo,
                    isVisible:true
                }
            });
            return;
        }
        dispatch({
            type: ActionTypes.setLoadingPage,
            data: true
          });
        AxiosInstance.post("maestros/actualizar-ficha-tecnica",{
            list_data:CopyInfo.map(item=>({
                cod_producto:cod_producto,
                cod_atributo_ft:item.atributo_codigo,
                valor:item.valor
            }))
        }).then(()=>{
            updateProdList(false);
            dispatch({
                type:ActionTypes.setModalInfo,
                data:{
                    title:"Ficha tecnica actualizada",
                    message:"Se ha actualizado la ficha tecnica del producto",
                    type:DialogType.exitoso,
                    isVisible:true
                }
            });
          
        }).catch(err=>{

            dispatch({
                type:ActionTypes.setModalInfo,
                data:{
                    title:"Error de actualizacion",
                    message:"Se ha presentado un error al tratar de actualizar la ficha tecnica",
                    type:DialogType.peligro,
                    isVisible:true
                }
            });

        }).finally(()=>{
            dispatch({
                type: ActionTypes.setLoadingPage,
                data: true
              });
        })


    }

    return (
        <Dialog

         open={isOpen}
        >
           <InputFileRaw/>
            <DialogTitle>
                Ficha tecnica del producto
            </DialogTitle>
            <DialogContent>
                <Grid container >
                    {
                        Clases.map(claseItem => <Grid key={claseItem.cod} item sm={12} xs={12} md={12} >
                            <Grid container >
                                {
                                    !["Cabecera"].includes(claseItem.label)?
                                    <Grid item sm={12} xs={12} md={12}  >
                                    <Typography variant="h6" >
                                    {claseItem.label}
                                    </Typography>
                                </Grid>:<></>
                                }
                                
                               
                                {
                                    fichaTecnica.filter(ele => ele.clase_cod === claseItem.cod).sort((a,b)=>a.atributo_orden-b.atributo_orden).map(element =>
                                        <Grid key={element.atributo_codigo} item sm={12} xs={12} md={12} >
                                            {renderItem(element)}
                                        </Grid>)
                                }
                            </Grid>
                        </Grid>
                        )

                    }
                 
                </Grid>
                <DialogActions>
                <Button 
                onClick={e=>setIsVisibleFichaTecnica(false)}
                variant="contained" color="secondary" >Cerrar</Button>
                    <Button disabled={disabled} variant="contained" onClick={onSendForm}  >Guardar</Button>
                </DialogActions>
            </DialogContent>
        </Dialog>

    )

}






